import './RenderWeeklyCommit.css';
import RenderWeeklyCommit from './RenderWeeklyCommit';

export default RenderWeeklyCommit;
